import React, {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PageLink} from '../../../../_metronic/layout/core'
import {CafeOrdersQueryParams, CafeOrdersClient} from '../../../infrastracture/api/CafeOrdersClient'
import SweetAlert from 'react-bootstrap-sweetalert'
import {TableHeader} from '../../../common/components/TableHeader'
import Pagination from 'react-responsive-pagination'
import RecordPerPageSelector from '../../../common/components/selectors/RecordPerPageSelector'
import {connect, shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {OrderStatus} from '../enums'
import {capitalizeFirstLetter} from '../../../common/helpers/stringHelper'
import Moment from 'react-moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap-v5'
import moment from 'moment'
import {SiteQueryParams, SitesClient} from '../../../infrastracture/api/SitesClient'
import {SiteStatus} from '../../sites/enums'

const CafeOrdersBreadCrumbs: Array<PageLink> = []

interface Props {}

const BumpScreen: React.FC<Props> = () => {
  const [cafeOrders, setCafeOrders] = useState<Array<any>>([])
  const [openCount, setOpenCount] = useState(0)
  const [completedCount, setCompletedCount] = useState(0)
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [siteOptions, setSiteOptions] = useState<any>([])
  const audioRef = React.useRef<HTMLAudioElement | null>(null)
  const previousOpenCountRef = React.useRef<number>(0)

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalRecords: 1,
    totalPages: 1,
    skip: 0,
    take: 50,
    reset: true,
    sort: 'created',
    direction: 'asc',
  })

  const [loading, setLoading] = useState(false)
  const [completingOrder, setCompletingOrder] = useState<string | null>(null)
  const [togglingOrder, setTogglingOrder] = useState<string | null>(null)
  const [showFilters, setShowFilters] = useState(false)
  const [filter, setFilter] = useState({
    date: moment().format('YYYY-MM-DD'),
    openOrders: true,
    site: '',
  })
  const [confirmCancel, setConfirmCancel] = useState<string | null>(null)
  const [lastRefreshed, setLastRefreshed] = useState<Date | null>(null)

  const permissions: any = useSelector<RootState>(
    ({auth}) => auth.userPermission,
    shallowEqual
  ) as any

  useEffect(() => {
    populateSiteOptions()
    // Initialize audio element with ping.mp3
    audioRef.current = new Audio(require('../../../../_metronic/assets/audio/ping.mp3'))
    audioRef.current.volume = 0.8
  }, [])

  useEffect(() => {
    if (pagination.reset) fetchData()
  }, [pagination])

  useEffect(() => {
    fetchData()
  }, [filter])

  useEffect(() => {
    // Set up timer for auto-refresh every 30 seconds
    const interval = setInterval(() => {
      if (filter.site && filter.openOrders) {
        fetchData()
      }
    }, 30000)

    // Cleanup interval on component unmount
    return () => clearInterval(interval)
  }, [filter])

  const populateSiteOptions = async () => {
    var query = new SiteQueryParams()
    query.WithCafeOnly(true)

    var data = (
      await SitesClient.LookUp(
        query.Paginate(0, 10000).WithStatus(SiteStatus.Active).Sort('name', 'asc')
      )
    ).data

    setSiteOptions(data.data)

    // If there are sites available and no site is currently selected, select the first one
    if (data.data && data.data.length > 0 && !filter.site) {
      setFilter((prevFilter) => ({
        ...prevFilter,
        site: data.data[0].id,
      }))
    }
  }

  async function fetchData() {
    if (!filter.site) return

    setLoading(true)
    try {
      var query = new CafeOrdersQueryParams()

      if (filter.site) query.WithSiteId(filter.site)

      var response = await CafeOrdersClient.ListBumpScreen(
        query
          .Search(search)
          .Sort(pagination.sort, pagination.direction)
          .Paginate(pagination.skip, pagination.take)
          .WithStatus(statusFilter || null)
          .WithDate(filter.date)
          .WithOpenOrders(filter.openOrders)
      )

      if (!response.authenticated) {
        // Handle authentication error
      } else {
        const {data} = response

        setCafeOrders(data?.orders || [])
        const newOpenCount = data?.openCount || 0

        // Play sound if there are new orders
        if (newOpenCount > previousOpenCountRef.current && filter.openOrders) {
          try {
            await audioRef.current?.play()
          } catch (err) {
            console.log('Audio play failed:', err)
          }
        }

        previousOpenCountRef.current = newOpenCount
        setOpenCount(newOpenCount)
        setCompletedCount(data?.completedCount || 0)
        setLastRefreshed(new Date())
      }
      setLoading(false)
    } catch (e) {
      console.error(e)
      setLoading(false)
    }
  }

  const handleCompleteOrder = async (orderId: string) => {
    setCompletingOrder(orderId)
    try {
      const response = await CafeOrdersClient.UpdateOrderStatus(orderId, 'complete')
      if (response.authenticated) {
        fetchData() // Refresh the data
      }
    } catch (error) {
      console.error('Error completing order:', error)
    } finally {
      setCompletingOrder(null)
    }
  }

  const handleCancelOrder = async (orderId: string) => {
    try {
      const response = await CafeOrdersClient.UpdateOrderStatus(orderId, 'cancelled')
      if (response.authenticated) {
        fetchData() // Refresh the data
      }
    } catch (error) {
      console.error('Error cancelling order:', error)
    }
    setConfirmCancel(null)
  }

  const handleToggleStatus = async (orderId: string, currentStatus: string) => {
    setTogglingOrder(orderId)
    try {
      const newStatus = currentStatus === OrderStatus.Complete ? 'unclaimed' : 'complete'
      const response = await CafeOrdersClient.UpdateOrderStatus(orderId, newStatus)
      if (response.authenticated) {
        fetchData() // Refresh the data
      }
    } catch (error) {
      console.error('Error toggling order status:', error)
    } finally {
      setTogglingOrder(null)
    }
  }

  const renderConfirmationAlerts = () => {
    if (confirmCancel) {
      return (
        <SweetAlert
          warning
          showCancel
          confirmBtnBsStyle='danger'
          title='Are you sure?'
          onConfirm={() => handleCancelOrder(confirmCancel)}
          onCancel={() => setConfirmCancel(null)}
          confirmBtnText={'Confirm'}
          cancelBtnBsStyle='light'
          showConfirm={true}
          showCloseButton
        >
          Do you want to cancel this order?
        </SweetAlert>
      )
    }

    return null
  }

  return (
    <>
      <div className='card'>
        <div
          className='card-header pt-5'
          style={{position: 'sticky', top: 0, zIndex: 100, backgroundColor: 'white'}}
        >
          <h3 className='card-title align-items-start flex-column'>
            <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
              <button
                type='button'
                className='btn btn-lg btn-primary'
                onClick={() => fetchData()}
                disabled={loading}
              >
                <span style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  Refresh
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm me-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </span>
              </button>
              <input
                type='text'
                className='form-control form-control-solid'
                placeholder='Search'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    setPagination({...pagination, reset: true})
                  }
                }}
                style={{width: '250px', display: showFilters ? 'block' : 'none'}}
              />
              <select
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={filter.site}
                onChange={(e) => {
                  setFilter({...filter, site: e.target.value})
                }}
                style={{display: showFilters ? 'block' : 'none'}}
              >
                <option value='' disabled selected>
                  Site
                </option>
                {siteOptions.map((i: any) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>

              <b style={{minWidth: '100px'}}>Open: {openCount}</b>
              {lastRefreshed && (
                <span style={{color: 'grey', minWidth: '100px'}}>
                  <Moment format='h:mm:ss A'>{lastRefreshed}</Moment>
                </span>
              )}
              <b style={{color: 'grey', minWidth: '150px'}}>Completed: {completedCount}</b>
            </div>
          </h3>
          <div className='card-toolbar'>
            <div className='form-check form-switch form-check-custom form-check-solid '>
              <input
                className='form-check-input'
                type='checkbox'
                onChange={(e: any) => setShowFilters(e.target.checked)}
                checked={showFilters}
              />
              <label className='form-check-label'>Filter</label>
            </div>
            <div
              className='form-check form-switch form-check-custom form-check-solid '
              style={{marginLeft: '15px'}}
            >
              <input
                className='form-check-input'
                type='checkbox'
                onChange={(e: any) => {
                  setFilter({...filter, openOrders: e.target.checked})
                  setPagination({
                    ...pagination,
                    reset: true,
                    sort: 'created',
                    direction: 'asc',
                  })
                }}
                checked={filter.openOrders}
              />
              <label className='form-check-label'>Open Orders</label>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '15px',
              }}
            >
              <span className='form-label fs-7 mb-0'>
                <b>Date</b>
              </span>
              <div className='' style={{marginLeft: '5px'}}>
                <input
                  type='date'
                  name='date'
                  placeholder=''
                  className='form-control form-control-solid'
                  id='date'
                  value={filter?.date}
                  onChange={(e) => {
                    setFilter({...filter, date: e.target.value})
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='card-body py-3' style={{padding: 0}}>
          <div
            style={{
              position: 'relative',
              height: 'calc(100vh - 100px)',
              display: 'flex',
              flexDirection: 'column',
              padding: '0px 10px',
            }}
          >
            <div style={{flexShrink: 0}}>
              <table
                className='table align-middle gs-0 gy-4 mb-0'
                style={{width: '100%', tableLayout: 'fixed'}}
              >
                <TableHeader
                  sort={pagination.sort}
                  direction={pagination.direction}
                  columns={[
                    {name: '', static: true, width: '10'},
                    {name: 'Product', static: true, width: '30'},
                    {name: 'User', static: true, width: '30'},
                    {name: 'Created', sort: 'created', width: '10'},
                    {name: 'Status', static: true, width: '10'},
                    {name: '', static: true, width: '10'},
                  ]}
                  onUpdate={(sort: any, direction: any) => {
                    setPagination({
                      ...pagination,
                      sort,
                      direction,
                      reset: true,
                    })
                  }}
                />
              </table>
            </div>
            <div style={{flex: 1, overflowY: 'auto'}}>
              <table
                className='table align-middle gs-0 gy-4 mb-0'
                style={{width: '100%', tableLayout: 'fixed'}}
              >
                <colgroup>
                  <col style={{width: '10%'}} />
                  <col style={{width: '30'}} />
                  <col style={{width: '30'}} />
                  <col style={{width: '10%'}} />
                  <col style={{width: '10%'}} />
                  <col style={{width: '10%'}} />
                </colgroup>
                <tbody>
                  {cafeOrders &&
                    cafeOrders.map((order: any) => (
                      <>
                        <tr key={order.id}>
                          <td>
                            {order.status === OrderStatus.Open && (
                              <button
                                type='button'
                                className='btn btn-lg btn-primary'
                                onClick={() => handleCompleteOrder(order.id)}
                                disabled={completingOrder === order.id}
                              >
                                <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                  Done
                                  {completingOrder === order.id && (
                                    <span
                                      className='spinner-border spinner-border-sm'
                                      role='status'
                                      aria-hidden='true'
                                    ></span>
                                  )}
                                </span>
                              </button>
                            )}
                          </td>
                          <td>
                            <span className='text-dark fw-bolder d-block fs-3'>
                              {order.product?.name || <i></i>}
                            </span>{' '}
                            <span
                              className='text-muted d-block fs-3'
                              style={{whiteSpace: 'nowrap'}}
                            >
                              {order.itemNames || <i></i>}
                            </span>
                          </td>
                          <td>
                            <span
                              className='text-dark fw-bolder d-block fs-3'
                              style={{paddingBottom: '20px'}}
                            >
                              {order.user?.name || <i></i>} {order.user?.surname || ''}
                            </span>
                          </td>
                          <td>
                            <span className='d-block fs-3' style={{color: 'grey'}}>
                              {order.created ? (
                                <Moment utc local format='HH:mm A'>
                                  {order.created}
                                </Moment>
                              ) : (
                                <i>Not specified</i>
                              )}
                            </span>
                          </td>
                          <td>
                            {order.completedDate && order.status === OrderStatus.Complete ? (
                              <OverlayTrigger
                                overlay={
                                  <Tooltip id='maxlimit-tooltip'>
                                    {order.completedUser &&
                                      `${order.completedUser.name} ${order.completedUser.surname}`}
                                    <br />
                                    <Moment utc local format='DD/MM/YYYY HH:mm A'>
                                      {order.completedDate}
                                    </Moment>
                                  </Tooltip>
                                }
                                placement='top'
                                trigger='hover'
                              >
                                <span
                                  className={`fs-3 badge badge-light-success fw-bolder`}
                                  onClick={() => handleToggleStatus(order.id, order.status)}
                                  style={{cursor: 'pointer'}}
                                >
                                  {togglingOrder === order.id ? (
                                    <span
                                      className='spinner-border spinner-border-sm'
                                      role='status'
                                      aria-hidden='true'
                                    ></span>
                                  ) : order.status ? (
                                    capitalizeFirstLetter(order.status.replace('-', ' '))
                                  ) : (
                                    <i>Not specified</i>
                                  )}
                                </span>
                              </OverlayTrigger>
                            ) : order.cancelledDate ? (
                              <OverlayTrigger
                                overlay={
                                  <Tooltip id='maxlimit-tooltip'>
                                    {order.cancelledUser &&
                                      `${order.cancelledUser.name} ${order.cancelledUser.surname}`}
                                    <br />
                                    <Moment utc local format='DD/MM/YYYY HH:mm A'>
                                      {order.cancelledDate}
                                    </Moment>
                                  </Tooltip>
                                }
                                placement='top'
                                trigger='hover'
                              >
                                <span className={`fs-3 badge badge-light-danger fw-bolder`}>
                                  {order.status ? (
                                    capitalizeFirstLetter(order.status.replace('-', ' '))
                                  ) : (
                                    <i>Not specified</i>
                                  )}
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <span
                                className={`fs-3 badge badge-light-${
                                  order.status === OrderStatus.Complete
                                    ? 'success'
                                    : order.status === OrderStatus.Unclaimed
                                    ? 'info'
                                    : order.status === OrderStatus.Cancelled
                                    ? 'danger'
                                    : 'primary'
                                } fw-bolder`}
                                onClick={() =>
                                  order.status === OrderStatus.Complete ||
                                  order.status === 'unclaimed'
                                    ? handleToggleStatus(order.id, order.status)
                                    : undefined
                                }
                                style={{
                                  cursor:
                                    order.status === OrderStatus.Complete ||
                                    order.status === 'unclaimed'
                                      ? 'pointer'
                                      : 'default',
                                }}
                              >
                                {togglingOrder === order.id ? (
                                  <span
                                    className='spinner-border spinner-border-sm'
                                    role='status'
                                    aria-hidden='true'
                                  ></span>
                                ) : order.status ? (
                                  capitalizeFirstLetter(order.status.replace('-', ' '))
                                ) : (
                                  <i>Not specified</i>
                                )}
                              </span>
                            )}
                          </td>
                          <td>
                            {order.status === OrderStatus.Open && (
                              <button
                                type='button'
                                className='btn btn-sm btn-danger'
                                onClick={() => setConfirmCancel(order.id)}
                              >
                                Cancel
                              </button>
                            )}
                          </td>
                        </tr>
                      </>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {renderConfirmationAlerts()}
    </>
  )
}

export default BumpScreen
